<!-- 吸底悬浮按钮 -->
<template>
  <div class="footerBtnContainer">
    <div class="footerBtn" :style="bgStyle" @click="handleClick"></div>
  </div>
</template>

<script>
import handleRedirect from '../mixins/pureHandleRedirect';

export default {
  props: {
    buttonImage: String
  },
  mixins: [handleRedirect],
  computed: {
    bgStyle() {
      return {
        background: `center / cover url("${this.buttonImage}") no-repeat`
      };
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: this.$t
        ? this.$t('track.base_comp_footer_btn')
        : '吸底悬浮按钮'
    });
  },
  methods: {
    handleClick() {
      this.$emit('reportEvent', {
        event: 'component_button_click',
        module_name: this.$t
          ? this.$t('track.base_comp_footer_btn')
          : '吸底悬浮按钮'
      });
      this.handleRedirect();
    }
  }
};
</script>

<style lang="less" scoped>
.footerBtnContainer {
  position: fixed;
  left: 0;
  bottom: 0;
  padding-bottom: calc(constant(safe-area-inset-bottom) * 2);
  padding-bottom: calc(env(safe-area-inset-bottom) * 2);
  width: 100%;
  background: #fff;

  .footerBtn {
    width: 100%;
    height: 98px;
  }
}
</style>
